export const construirPayloadEvento = ({
  sessionId,
  paso,
  evento,
  descripcion,
  campo = null,
  valor = null,
  contextData = {},
  utmData = {},
  flujoActivo = {}
}) => {
  return {
    token: '123abcSECRET',
    session_id: sessionId,
    pac_rut: contextData?.pacRut || null,
    paso,
    evento,
    descripcion,
    campo_afectado: campo,
    valor_ingresado: valor,
    user_agent: navigator.userAgent,
    origen_referrer: document.referrer || null,
    dispositivo: contextData?.dispositivoTipo || '-',
    sistema_operativo: contextData?.sistemaOperativo || '-',
    navegador: contextData?.navegador || '-',
    utm_source: utmData?.source || null,
    utm_medium: utmData?.medium || null,
    utm_campaign: utmData?.campaign || null,
    utm_term: utmData?.term || null,
    utm_content: utmData?.content || null,
    mp_origen: flujoActivo?.mp_origen || null,
    proyecto: 'agendamiento_web'
  };
};

